import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import { AppShell } from '@/components/shell/AppShell';
import { meQueryOptions } from '@/features/auth/useSession';
import { useDashboardCounts } from '@/features/dashboard/hooks';
import { useRunningScansCount } from '@/features/scans/hooks';
import { useActiveSeedsCount } from '@/features/seeds/hooks';
import { ApiError } from '@/lib/api';

export const Route = createFileRoute('/_auth')({
  beforeLoad: async ({ context, location }) => {
    try {
      const me = await context.queryClient.ensureQueryData(meQueryOptions());
      return { me };
    } catch (error) {
      if (error instanceof ApiError && error.status === 401) {
        throw redirect({ to: '/login', search: { redirect: location.href } });
      }
      throw error;
    }
  },
  component: AuthenticatedLayout,
});

// Compteurs de la sidebar (T34) : seeds actives (`GET /seeds`), scans en cours (`GET /scans`),
// à trier / shortlist / expériences en cours (une seule requête `GET /dashboard`).
function AuthenticatedLayout() {
  const { data: seeds } = useActiveSeedsCount();
  const { data: scans } = useRunningScansCount();
  const { data: dashboard } = useDashboardCounts();
  return (
    <AppShell counts={{ seeds, scans, ...dashboard }}>
      <Outlet />
    </AppShell>
  );
}
